module.exports = __webpack_public_path__ + "media/app/assets/specializations/evoker/devastation-2e998755fc16f8fe0c2baa5e1531c2a7.png";